var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useState } from "react";
import { PeekBox, PeekDivider, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { USER_ROLES } from "@constants/Roles";
import CustomRadio from "./utils/CustomRadio";
import CustomAccordion from "./utils/CustomAccordion";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { ScanRequestPermission, SettingsCommunities, CustomSubtitle, AnalyticsPermission, ProspectIntelligencePermission, } from "./utils";
const getRoleNameMapping = (intl) => ({
    Basic: intl.formatMessage(messages.basicUserRole),
    Insights: intl.formatMessage(messages.insightsUserRole),
    Agent: intl.formatMessage(messages.agentUserRole),
    Scanner: intl.formatMessage(messages.scannerUserRole),
    Owner: intl.formatMessage(messages.ownerUserRole),
    OrgAdmin: intl.formatMessage(messages.orgAdminUserRole),
});
const DetailsContent = ({ role, form }) => {
    const intl = useIntl();
    if (role === USER_ROLES.Basic || role === USER_ROLES.Agent) {
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomSubtitle, { subtitle: intl.formatMessage((role === USER_ROLES.Basic && messages.basicUserDescription) || messages.agentUserDescription) }),
            React.createElement(PeekDivider, { light: true }),
            React.createElement(ScanRequestPermission, null),
            React.createElement(PeekDivider, { light: true }),
            React.createElement(AnalyticsPermission, null),
            React.createElement(PeekDivider, { light: true }),
            React.createElement(ProspectIntelligencePermission, null),
            React.createElement(PeekDivider, { light: true }),
            React.createElement(SettingsCommunities, { form: form })));
    }
    if (role === USER_ROLES.Scanner) {
        return React.createElement(SettingsCommunities, { form: form });
    }
    if (role === USER_ROLES.Owner) {
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomSubtitle, { subtitle: intl.formatMessage(messages.scanRequestPolicy) }),
            React.createElement(PeekDivider, { light: true }),
            React.createElement(SettingsCommunities, { form: form })));
    }
    return null;
};
export const UserTypeSelector = (_a) => {
    var { field, label, form, rolesOptions } = _a, props = __rest(_a, ["field", "label", "form", "rolesOptions"]);
    const intl = useIntl();
    const [selectedOption, setSelectedOption] = useState(field.value || "");
    const selectItems = useMemo(() => {
        const roleNameMapping = getRoleNameMapping(intl);
        return Object.entries(USER_ROLES)
            .filter(([_key, value]) => rolesOptions.includes(value))
            .map(([key, value]) => ({
            id: value,
            name: roleNameMapping[key] || key,
        }));
    }, [rolesOptions]);
    const handleOptionChange = (id) => {
        setSelectedOption(id);
        // @ts-ignore
        form.setFieldValue(field.name, id);
    };
    return (React.createElement(PeekStack, Object.assign({ spacing: 1 }, props),
        React.createElement(PeekTypography, { variant: "h4", my: 1, textTransform: "capitalize" }, label),
        selectItems.map((item) => (React.createElement(CustomAccordion, { key: item.id, expanded: selectedOption === item.id, onChange: () => handleOptionChange(item.id), summaryContent: React.createElement(CustomRadio, { isChecked: selectedOption === item.id, label: item.name, onClick: () => handleOptionChange(item.id), "data-testid": `user-role-selector-${item.id}` }), detailsContent: ![USER_ROLES.OrgAdmin, USER_ROLES.Insights].includes(item.id) && (React.createElement(PeekBox, { px: 1 },
                React.createElement(PeekStack, { spacing: 1.5 },
                    React.createElement(DetailsContent, { role: item.id, form: form })))) })))));
};
export default UserTypeSelector;
